import { FeatureFlags } from '../models/feature-flags.model';

export interface FeatureFlagsState {
	flags: FeatureFlags;
	loaded: boolean;
	loading: boolean;
	error: string | null;
}

export const initialFeatureFlagsState: FeatureFlagsState = {
	flags: {},
	loaded: false,
	loading: false,
	error: null
};
